import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import { getUserTypesByIds } from '../../../services/taxonomies/user-types';
import { getInstitutionsByIds } from '../../../services/taxonomies/institutions';

const InstitutionsList = ({ form, userTypesIds, setCurrentInstitutionId }) => {
  const [institutions, setInstitutions] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userTypes = await getUserTypesByIds(userTypesIds)({
          criterias: { deleted: false, page: 0, size: 10000 },
        });
        const institutionsIds = userTypes.content.map(
          (item) => item.institutions,
        );
        const response = await getInstitutionsByIds(institutionsIds)({
          criterias: { deleted: false, page: 0, size: 10000 },
        });
        setInstitutions(response.content);
      } catch (error) {
        console.error('Error fetching user types:', error);
      }
    };

    if (userTypesIds?.length) {
      fetchData();
    }
  }, [userTypesIds]);

  const internalValue = useMemo(() => {
    return form.getFieldValue('Oraganizatie');
  }, [form]);

  const handleChange = useCallback(
    (val, obj) => {
      form.setFieldsValue({ Oraganizatie: val });
      setCurrentInstitutionId(obj?.key ? obj.key : null);
    },
    [form, setCurrentInstitutionId],
  );

  return (
    <Select
      allowClear
      value={internalValue}
      onChange={handleChange}
      showSearch
      optionFilterProp="children"
    >
      {institutions &&
        institutions.map(({ id, name }) => (
          <Select.Option key={id} value={name}>
            {name}
          </Select.Option>
        ))}
    </Select>
  );
};

export default InstitutionsList;
